module.exports = __webpack_public_path__ + "static/media/rocketsurgery.701a11e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/rocketsurgery.jpg
// module id = 301
// module chunks = 0